export default {
  "menu.ResultPage": "结果",
};